
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-8 -8)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#252626","d":"M15 28h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1zm7-1V17a1 1 0 00-1-1h-2a1 1 0 00-1 1v10a1 1 0 001 1h2a1 1 0 001-1zm6 0V13a1 1 0 00-1-1h-2a1 1 0 00-1 1v14a1 1 0 001 1h2a1 1 0 001-1z"}})])])
          )
        }
      }
    